import * as React from 'react'
import dynamic from 'next/dynamic'

import Header from '@components/demo/Header'
import Footer from '@components/demo/Footer'
import Contact from '@components/demo/Contact'
import ImgSet from '@components/demo/ImgSet'
import UploadForm from '@components/demo/UploadForm'
import UploadResult from '@components/demo/UploadResult'
import CTAButton from '@components/demo/CTAButton'

import {t, axios} from '@lib/helpers'

const Meta = dynamic(() => import('@components/Meta'))

const Page = ({isRecaptchaValidated}) => {
  return (
    <React.Fragment>
      <Meta title={`WowEmbedding – ${t('layout.title')}`} />

      <div className='DemoDetail FaceEmbedding'>
        <Header name='WowEmbedding' />

        <div className='DemoDetail__wrapper'>
          <Hero />
          <Why />
        </div>

        <Upload isRecaptchaValidated={isRecaptchaValidated} />

        <Contact isRecaptchaValidated={isRecaptchaValidated}>
          <div className='DemoDetail__spec'>
            <div className='container'>
              <p className='DemoDetail__spec__p'>
                {t('pages.demo.face_embedding.spec.p1')}
              </p>
              <p className='DemoDetail__spec__p'>
                {t('pages.demo.face_embedding.spec.p2')}
              </p>
              <p className='DemoDetail__spec__p'>
                {t('pages.demo.face_embedding.spec.p3')}
              </p>
            </div>
          </div>
        </Contact>

        <Footer />
      </div>
    </React.Fragment>
  )
}

const Hero = () => {
  return (
    <section className='DemoDetail__hero'>
      <video
        className='DemoDetail__hero__video'
        playsInline
        autoPlay
        muted
        loop
      >
        <source src='/videos/demo/face-embedding.mp4' type='video/mp4' />
      </video>
      <div className='container'>
        <div className='DemoDetail__hero__content'>
          <h1
            className='DemoDetail__title DemoDetail__title--hilight'
            dangerouslySetInnerHTML={{
              __html: t('pages.demo.face_embedding.hero.title'),
            }}
          />
          <h4>{t('pages.demo.face_embedding.hero.subtitle')}</h4>
          <CTAButton />
        </div>
      </div>
    </section>
  )
}

const Why = () => {
  return (
    <section className='DemoDetail__why'>
      <div className='container' id='why'>
        <div className='DemoDetail__why__img'>
          <ImgSet
            src='/images/demo/face-embedding/why.jpg'
            alt='Face Embedding'
          />
        </div>

        <div className='DemoDetail__why__content'>
          <h2
            className='DemoDetail__title DemoDetail__title--hilight'
            dangerouslySetInnerHTML={{
              __html: t('pages.demo.face_embedding.why.title'),
            }}
          />
          <p>{t('pages.demo.face_embedding.why.description')}</p>
        </div>
      </div>
    </section>
  )
}

const Upload = ({isRecaptchaValidated}) => {
  const [result, setResult] = React.useState('')

  const handleChange = async (file) => {
    const formData = new FormData()
    formData.append('image', file)

    try {
      const response = await axios.post('/demo/faces', formData, {
        headers: {
          'X-Api-Key': 'Data wow',
        },
      })
      setResult(JSON.stringify(response.data.data.results, null, 2))
    } catch (err) {
      setResult('Something wrong please try again.')
    }
  }

  return (
    <section className='DemoDetail__upload' id='upload'>
      <header>
        <div className='container'>
          <h2 className='DemoDetail__title DemoDetail__title--hilight'>
            Face Embedding API
          </h2>
        </div>
      </header>

      <hr />

      <div className='DemoDetail__upload__content'>
        <UploadForm
          name='WowEmbedding'
          onChange={handleChange}
          isLoading={isRecaptchaValidated}
        />

        <UploadResult result={result} />
      </div>
    </section>
  )
}

export default Page
